export interface IGISPurchaseRefundRequest {
    PurchaseID: number;
    RefundReason: string;
}

export class GISPurchaseRefundRequest implements IGISPurchaseRefundRequest {
    PurchaseID: number;
    RefundReason: string;
}
